import * as $ from 'jquery';
import { Component, OnInit, HostListener, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ConfigService } from '../../../../services/infrastructure/config.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { SeedReplantService } from '../../../../services/seed/seed-replant/seed-replant.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { SeedReplantAddReplantProductSliderModelService } from './seed-replant-add-replant-product-slider-model.service';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-seed-replant-add-replant-product',
  templateUrl: './seed-replant-add-replant-product.component.html',
  styleUrls: ['./seed-replant-add-replant-product.component.scss']
})
export class SeedReplantAddReplantProductComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  filterOptionsData: Array<FilterOption>;
  productAllDataSource: any;
  parentAccountDataSource: any;
  private selectedTabIndex = 0;
  filters: any;
  itemList = new Array();
  tabProductList: any;
  selectedProductList = new Array();
  invoiceProductList: any;
  nonInvoiceProductList: any;
  isNoProduct = false;
  isProductNotAdded = true;
  displayedColumns: string[] = ['Product Name', 'Available Units', 'Pack Size', 'Technology', 'Treatment', 'Product Line', 'LotNumber'];

  constructor(
    private configService: ConfigService,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private localStorageService: LocalStorageService,
    private seedReplantRequestService: SeedReplantService,
    private seedReplantProductSliderModelService: SeedReplantAddReplantProductSliderModelService) { }

  ngOnInit(): void {
    this.setFilter();
    this.setDropDownValues();
    this.getSeedReplantProduct(false);
  }

  setFilter() {
    this.filterOptionsData = [
      { label: 'Product Name', key: 'productName', controlType: ControlType.Text },
      { label: 'Marketing Brand', key: 'marketingBrand', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Package Size', key: 'packageSize', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Seed Size', key: 'seedSize', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Technology', key: 'technology', controlType: ControlType.Text },
      { label: 'Treatment', key: 'treatment', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Item Number', key: 'itemNumber', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'value' },
      { label: 'Product Line', key: 'productLine', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Lot Number', key: 'lotNumber', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' }
    ];
  }

  // Set Drop down values for filter
  setDropDownValues() {
    // get lot list based on selected account
    this.subscription.push(this.seedReplantRequestService.getLotMasterList(this.seedReplantRequestService.getSelectedAccountNo()).subscribe((result: any[]) => {
      if (result && result.length > 0) {
        this.filterOptionsData.find(x => x.key === 'lotNumber').controlData = result.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
      }
    }));

    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST)) {
      this.filterOptionsData.find(x => x.key === 'marketingBrand').controlData = JSON.parse(this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.filterOptionsData.find(x => x.key === 'packageSize').controlData = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'seedSize').controlData = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'treatment').controlData = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // Item Number master data
    if (this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'itemNumber').controlData = JSON.parse(this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST));
    }

    // Product Line data
    this.subscription.push(this.seedReplantRequestService.getProductLineList().subscribe((result: any[]) => {
      if (result && result.length > 0) {
        this.filterOptionsData.find(x => x.key === 'productLine').controlData = result;
      }
    }));
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    if (this.selectedTabIndex === 0) {
      this.setAccInvProdTableHeight();
    } else if (this.selectedTabIndex === 1) {
      this.setcompInvProdTableHeight();
    }
  };

  // set Add product table height
  setAccInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.seed-return-add-prod .accInvProdTable').css('max-height', tableHeight + 'px');
  }

  setcompInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.seed-return-add-prod .compInvProdTable').css('max-height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccInvProdTableHeight();
    this.setcompInvProdTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    //this.setAccInvProdTableHeight();
    //this.setcompInvProdTableHeight();
  }

  // Update selected prodcut list
  keepRecords(product, isParentTab) {
    product.IsProductSelected = !product.IsProductSelected;
    const itemNumber = product.itemNumber;
    const lotNumber = product.lotNumber;
    const isParent = product.isParent;
    if (product.IsProductSelected) {
      this.itemList.push({ 'itemNumber': itemNumber, 'lotNumber': lotNumber });
      let item;
      if (isParentTab) {
        item = this.nonInvoiceProductList.filter(i => i.itemNumber == itemNumber && i.lotNumber == lotNumber && i.isParent == isParent);
      } else {
        item = this.invoiceProductList.filter(i => i.itemNumber == itemNumber && i.lotNumber == lotNumber && i.isParent == isParent);
      }

      this.selectedProductList.push(item[0]);
    }
    else {
      let index = this.itemList.findIndex(x => x.itemNumber == itemNumber && x.lotNumber == lotNumber);
      if (index !== -1) {
        this.itemList.splice(index, 1);
      }
      index = this.selectedProductList.findIndex(x => x.itemNumber == itemNumber && x.lotNumber == lotNumber);
      if (index !== -1) {
        this.selectedProductList.splice(index, 1);
      }
    }
    this.enableDisableAddProductBtn();
  }

  // Enable or disable Add product to order btn based on item selection
  enableDisableAddProductBtn() {
    if (this.selectedProductList.length > 0) {
      this.isProductNotAdded = false;
    }
    else {
      this.isProductNotAdded = true;
    }
  }

  // Selected product will add on order
  addSelectedProductToOrder() {
    const data = [];
    if (this.selectedProductList.length > 0) {
      this.selectedProductList.forEach(x => {
        data.push(x);
      });
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: data.length });
    }
    this.seedReplantProductSliderModelService.setData<SeedReplantAddReplantProductSliderModelService[]>(data);
    this.seedReplantProductSliderModelService.close();
  }

  // Filter Search
  filterSearchClick(event) {
    this.filters = {
      accountNumber: this.seedReplantRequestService.getSelectedAccountNo(),
      productName: event.productName,
      marketingBrand: event.marketingBrand,
      packageSize: event.packageSize,
      seedSize: event.seedSize,
      technology: event.technology,
      treatment: event.treatment,
      itemNumber: event.itemNumber,
      productLine: event.productLine,
      lotNumber: event.lotNumber
    };
    this.getSeedReplantProduct(true);
  }

  // Clear All Filter
  filterClearAllClick(event) {
    this.getSeedReplantProduct(false);
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  getSeedReplantProduct(isFilter) {
    if (!isFilter) {
      this.filters = {
        accountNumber: this.seedReplantRequestService.getSelectedAccountNo(),
      };
    }

    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.seedReplantRequestService.getReplantProductItems(this.filters).subscribe((result: any) => {
      if (result) {
        this.tabProductList = result;

        // Filter the data based on selected and not saved
        const newItem = this.seedReplantProductSliderModelService.getNewItem();
        if (newItem != undefined) {
          const data = this.tabProductList.filter(x => !newItem.includes(x.itemId));
          this.tabProductList = data;
        }

        result.forEach(x => {
          if (this.selectedProductList.find(s => s.itemNumber == x.itemNumber && s.lotNumber == x.lotNumber && s.isParent == x.isParent)) {
            x.IsProductSelected = true;
          }
        });

        this.loaderService.setLoaderStatus(false);

        this.invoiceProductList = this.tabProductList.filter(x => x.isParent == false);
        this.productAllDataSource = new MatTableDataSource(this.invoiceProductList);

        this.nonInvoiceProductList = this.tabProductList.filter(x => x.isParent == true);
        this.parentAccountDataSource = new MatTableDataSource(this.nonInvoiceProductList);

        if (isFilter) {
          this.isNoProduct = (this.invoiceProductList.length == 0) ? true : false;
        } else {
          if (this.selectedTabIndex == 0) {
            this.isNoProduct = (this.invoiceProductList.length == 0) ? true : false;
          } else {
            this.isNoProduct = (this.nonInvoiceProductList.length == 0) ? true : false;
          }
        }
        this.setAccInvProdTableHeight();
        this.setcompInvProdTableHeight();
      }
    }));
  }
}
